import { Grid } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { withStyles } from '@mui/styles';
import React, { useState } from 'react';

import WsColors from '../../WsColors';

const StyledTabs = withStyles({
  indicator: {
    display: 'none',
  },
})(Tabs);

const StyledTab = withStyles(() => ({
  root: {
    textTransform: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
}))(Tab);

interface IScrollList {
  tabName: string;
  tabCount?: number;
  icon?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
}

interface IScrollableButtonTabs {
  scrollList: IScrollList[];
  getTabIndex(args: number): void;
  variant?: string;
  defaultValue?: number;
  className?: string;
}

const ScrollableButtonTabs: React.FC<IScrollableButtonTabs> = ({
  scrollList,
  getTabIndex,
  variant = 14,
  defaultValue,
  className,
}) => {
  const [tabValue, setTabValue] = useState<number>();
  const [scrollArray, setScrollArray] = React.useState<IScrollList[]>([]);

  React.useEffect(() => {
    setScrollArray(scrollList);
    setTabValue(defaultValue);
  }, [defaultValue, scrollList]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    getTabIndex(newValue);
    setTabValue(newValue);
  };

  const addTabElement = (total: number | string, tabLabel: string, id: number) => (
    <Grid
      alignItems="center"
      columnGap={0.5}
      display="flex"
      sx={
        id !== tabValue
          ? { color: WsColors.TertiaryShades900 }
          : {
              background: WsColors.TheBlues500,
              color: WsColors.White,
              py: 1,
              px: 1.5,
              borderRadius: 1,
            }
      }
      direction="row"
      spacing={1}
    >
      {`${tabLabel} ${total ? `(${total ?? ''})` : ''}`}
    </Grid>
  );

  return (
    <>
      <StyledTabs
        value={tabValue}
        onChange={handleChange}
        className={className}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
        visibleScrollbar={true}
      >
        {scrollArray.map((tab: IScrollList, index: number) => {
          return (
            <StyledTab
              sx={{
                fontSize: variant,
              }}
              icon={tab.icon}
              iconPosition="start"
              key={index}
              label={addTabElement(tab.tabCount ? tab.tabCount : '', tab.tabName, index)}
            />
          );
        })}
      </StyledTabs>
    </>
  );
};

export default ScrollableButtonTabs;
